export default __webpack_public_path__ + "static/media/IMG_9413.9a2e1d4b.JPG";